module.exports = __webpack_public_path__ + "static/016.thumb-0bc8b383046775f550942242947f83e9.jpg";